module.exports = __webpack_public_path__ + "media/images/emoticons/riceball-7b79121640745d203af19952183a294e.gif";